import { HTTPError } from 'ky';
import { toast } from 'sonner';

export interface RuntimeErrorResponse {
  code?: number;
  data?: unknown;
  message?: string;
}

export const INFLUENCER_DISCOVERY_CAPACITY_ERROR_CODE = 107;

export async function getRuntimeErrorResponse(
  error: unknown,
): Promise<RuntimeErrorResponse | null> {
  if (!(error instanceof HTTPError)) {
    return null;
  }

  try {
    // The runtime API responds with { code, data, message }, which differs from the OpenAPI schema.
    const data = await error.response.clone().json();

    if (!data || typeof data !== 'object') {
      return null;
    }

    return data as RuntimeErrorResponse;
  } catch {
    return null;
  }
}

export async function getInfluencerDiscoveryCapacityError(
  error: unknown,
): Promise<RuntimeErrorResponse | null> {
  const runtimeError = await getRuntimeErrorResponse(error);

  if (runtimeError?.code !== INFLUENCER_DISCOVERY_CAPACITY_ERROR_CODE) {
    return null;
  }

  return runtimeError;
}

export async function toastRuntimeError(error: unknown, defaultMessage?: string) {
  const errorRes = await getRuntimeErrorResponse(error);
  if (errorRes?.message) {
    toast.error(errorRes.message);
  } else if (defaultMessage) {
    toast.error(defaultMessage);
  }
}
